import { combineReducers } from '@reduxjs/toolkit';
import { createEnrichReducers, ENRICH_REDUX_SLICE_KEY } from '@groupby/enrich-console';
import { categoriesApi, ccApi, recommendationsResultsApi, searchApi, searchProductApi, } from '../api';
import notifications from '@/store/slices/notificationsSlice';
import session from '@/store/slices/sessionSlice';
import releaseNotes from './release-notes.reducers';
import attributesByCollection from './attribute-short';
import collections from '../slices/collectionsSlice';
import areas from '../slices/areasSlice';
import { REF_APP_SLICE_KEY, refAppReducer } from '@/search-for-retail/evaluate';
const enrichReducer = createEnrichReducers();
export default function createReducers() {
    return combineReducers({
        notifications,
        session,
        releaseNotes,
        attributesByCollection,
        collections,
        areas,
        [REF_APP_SLICE_KEY]: refAppReducer,
        [ENRICH_REDUX_SLICE_KEY]: enrichReducer,
        [ccApi.reducerPath]: ccApi.reducer,
        [searchApi.reducerPath]: searchApi.reducer,
        [recommendationsResultsApi.reducerPath]: recommendationsResultsApi.reducer,
        [categoriesApi.reducerPath]: categoriesApi.reducer,
        [searchProductApi.reducerPath]: searchProductApi.reducer,
    });
}
